import React from 'react';
import { BalloonArtistPricingTool } from './BalloonArtistPricingTool'; // 1. IMPORT
import './App.css'; // You can keep or remove this

function App() {
  return (
    <div className="App">
      {/* 2. USE THE COMPONENT */}
      <BalloonArtistPricingTool />
    </div>
  );
}

export default App;